window.onload = ( $ => {

	/**
	 * Initialize custom select controls
	 *
	 * @private
	 */

	// check if string includes some content
	const __checkRecurringText = function (item) {
		if (item.textContent.toLowerCase().includes('coupon')) {
			item.textContent = '';
		}

		if (item.textContent.includes('>')) {
			item.textContent = '';
		}
	}

	// removing checked content in the checkRecurringText function
	const __removeRecurringTotal = function () {
		let recurringTotal = document.querySelector('.woocommerce-checkout .cart-discount.recurring-total td');
		if (recurringTotal) {
			recurringTotal.childNodes.forEach(item => {
				__checkRecurringText(item);
			})
		}

		$(document).on('updated_checkout', function () {
				recurringTotal = document.querySelector('.woocommerce-checkout .cart-discount.recurring-total td');
				if (recurringTotal) {
					recurringTotal.childNodes.forEach(item => {
						__checkRecurringText(item);
					})
				}
		})
	}

	const __init_custom_selects = function() {



		const selectCheckoutBillingCountry = document.querySelector('select#billing_country'),
			selectCheckoutShippingCountry = document.querySelector('select#shipping_country'),
			selectCheckoutBillingState = document.querySelector('select#billing_state'),
			selectCheckoutShippingState = document.querySelector('select#shipping_state')

		const choicesEnable = (element) => {
			const choices = new Choices(element, {
				shouldSort: false,
				searchEnabled: true,
				searchChoices: true,
				itemSelectText: '',
				placeholder: true,
				position: 'bellow'
			})
		}

		if (selectCheckoutBillingCountry || selectCheckoutShippingCountry || selectCheckoutBillingState || selectCheckoutShippingState) {
			setTimeout(function (  ) {
				$('#billing_country_field .woocommerce-input-wrapper').off('click');
				$('#billing_state_field .woocommerce-input-wrapper').off('click');
				$('#shipping_country_field .woocommerce-input-wrapper').off('click');
				$('#shipping_state_field .woocommerce-input-wrapper').off('click');
			}, 3000)

			choicesEnable(selectCheckoutBillingCountry, 'p#billing_country_field > label')
			choicesEnable(selectCheckoutShippingCountry, 'p#shipping_country_field > label')
			if (selectCheckoutBillingState !== null || selectCheckoutShippingState !== null) {
				choicesEnable(selectCheckoutBillingState)
				choicesEnable(selectCheckoutShippingState)
			}

			$(document).on('ajaxSend', function () {
				if ($('select#billing_state').length > 0) {
					choicesEnable(document.getElementById('billing_state'))
				} else if ($('input#billing_state').length > 0) {
					$('#billing_state_field').find('.woocommerce-input-wrapper').append($('#billing_state_field').find('input#billing_state'))
					$('#billing_state_field').find('.choices').remove()
					$('p#billing_state_field > label').removeAttr('style')
				}

				if ($('select#shipping_state').length > 0) {
					choicesEnable(document.getElementById('shipping_state'))
				} else if ($('input#shipping_state').length > 0) {
					$('#shipping_state_field').find('.woocommerce-input-wrapper').append($('#shipping_state_field').find('input#shipping_state'))
					$('#shipping_state_field').find('.choices').remove()
					$('p#shipping_state_field > label').removeAttr('style')
				}
			})

			$('.woocommerce-billing-fields, .woocommerce-shipping-fields').on('click', function () {

				let interval = setInterval(function () {
					$('#billing_country_field').find('.choices__input').attr('placeholder', 'choose country')
					$('#shipping_country_field').find('.choices__input').attr('placeholder', 'choose country')
					$('#billing_state_field').find('.choices__input').attr('placeholder', 'choose state')
					$('#shipping_state_field').find('.choices__input').attr('placeholder', 'choose state')
				}, 500)

				setTimeout(function () {
					clearInterval(interval);
				}, 20000);
			});

		}
	}

	return {
		/**
		 * Call to init ourselves only when we are on our custom cart page
		 */
		init: function() {
			if ( !$( '.woocommerce-checkout' ).length ) return false;
			if ("1" === window.myajax.checkout_choises_allowed) __init_custom_selects();
			__removeRecurringTotal();
			return true;
		}
	}

} )( jQuery.noConflict() ).init();
